import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import { Input } from "@/components/ui/input";
import { ID_REGEX } from "@/constants";
import { isRequired } from "@/lib/form";
import { ReadStoreFormat, WriteStoreFormat } from "@/types/storeFormat";
import { useTranslation } from "react-i18next";

const DictionaryFormFields = () => {
  const { t } = useTranslation();
  const { config } = useDictionaryContext<ReadStoreFormat, WriteStoreFormat>();
  const { schema, ns } = config;
  return (
    <Fieldset className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {Object.entries(schema.shape)
        .filter(([key]) => !ID_REGEX.test(key))
        .map(([key, field], index) => (
          <Field
            key={index}
            name={key}
            label={t(`${ns}.fields.${key}`)}
            required={isRequired(field)}
            render={({ field }) => <Input className="w-full" {...field} />}
          />
        ))}
    </Fieldset>
  );
};

export default DictionaryFormFields;
